<div [tabscroll]="false" class="flex-column full-size">
  <div>
    @if (showNewProject) {
      <mat-toolbar class="mat-toolbar-action-header">
        <span style="flex: 1 1 1e-09px; box-sizing: border-box;"></span>
        <div>
          <button type="button" kendoButton themeColor="primary" color="primary" [buttonLoading]="isAddingProject" [svgIcon]="icons.save" [disabled]="isAddingProject" type="submit" (click)="callNext($event)">Save</button>
          <button type="button" kendoButton themeColor="primary" color="primary" [svgIcon]="icons.cancel" [disabled]="isAddingProject" (click)="cancelReset($event)">Cancel</button>
        </div>
      </mat-toolbar>
    }

    <!--using mat-toolbar here for now, until we're able to update the styles of app-header across the board-->
    @if (projectProperties && projectProperties.ProjectId > 0) {
      <mat-toolbar class="mat-toolbar-action-header">
        <div class="header-title">
          {{projectProperties.Name}} <span class="dp-label">({{projectProperties.ProjectId}})</span>
        </div>
        <span style="flex: 1 1 1e-09px; box-sizing: border-box;"></span>
        <div>
          <button type="button" [disabled]="!saveActivate(formState, formValid) || saving" kendoButton themeColor="primary" [buttonLoading]="saving" [svgIcon]="icons.save" (click)="saveTabs($event)"> Save</button>
          <button type="button" [disabled]="!saveActivate(formState, formValid) || saving" kendoButton themeColor="primary" [buttonLoading]="saving" [svgIcon]="icons.cancel" (click)="cancelModify($event)"> Cancel</button>
        </div>
      </mat-toolbar>
    }
  </div>

  <!-- New Project -->
  <kendo-tabstrip class="sub-tabstrip flex-grow full-size-one" [keepTabContent]="true" [animate]="false" (tabSelect)="handleTabSelect($event)">
    @if (projectProperties && projectProperties.ProjectId < 1) {
      <kendo-tabstrip-tab class="flex-column" [title]="'Create Project'" [selected]="true">
        <ng-template kendoTabContent>
          <app-project-create-new
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (doesProjectExist)="readProjectExist($event)"
            (shouldShowNewProject)="readShowNew($event)"
            (isValidNewProject)="readValidNewProject($event)"
            (setParameterTabVisibility)="setTabVisibilityFromProjectCreate($event)"
            #ProjectCreateComponent>
          </app-project-create-new>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Header -->
    @if (projectProperties && projectProperties.ProjectId > 0) {
      <kendo-tabstrip-tab class="flex-column" [selected]="true">
        <ng-template kendoTabTitle style="border-bottom: 3px solid red;">
          <div [ngClass]="{'invalid-tab': validateTabs['header'] === false}">
            {{ headerTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-header-data
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTitle)="readHeaderTab($event)"
            (tabTdv)="readHeaderTabTdv($event)"
            (headerStatus)="handleHeaderStatusChange($event)">
          </app-project-header-data>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Parameters -->
    @if (projectProperties && projectProperties.ProjectId > 0 && showParameterTab) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['parameter'] === false}">
            {{ parametersTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-details class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTdv)="readParametersTabTdv($event)"
            (saveComplete)="detailsTabSaveComplete($event)"
            #AppProjectDetails>
          </app-project-details>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Asset Mapping -->
    @if (projectProperties && projectProperties.ProjectId > 0) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <span [ngClass]="{'invalid-owid' : _projectAssetMappingComponent()?.isOwidValueMissing === true}">
            <div [ngClass]="{'invalid-tab': validateTabs['assetmapping'] === false}">
              {{ assetMappingTabTitle | titlecase }}
            </div>
          </span>
        </ng-template>
        <ng-template kendoTabContent>
          @if (projectProperties && projectProperties.ProjectId > 0) {
            <app-project-asset-mapping class="full-size flex-100"
              [projectTab]="projectProperties"
              (tabTitle)="readAssetMappingTab($event)"
              (tabTdv)="readAssetMappingTabTdv($event)">
            </app-project-asset-mapping>
          }
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Planning -->
    @if (projectProperties && projectProperties.ProjectId > 0 && (showTankBatteryTabs || showSWDFacilityPlanningTab)) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['schedule'] === false}">
            {{ planningabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-planning
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTitle)="readPlanningTab($event)"
            (tabTdv)="readPlanningTabTdv($event)"
            #AppProjectEventLog>
            ></app-project-planning>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Scoping -->
    @if (projectProperties && projectProperties.ProjectId > 0 && showTankBatteryTabs) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['schedule'] === false}">
            {{ scopingTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-scoping-index
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTitle)="readScopingTab($event)"
            (tabTdv)="readScopingTabTdv($event)">
          </app-project-scoping-index>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Well Mapping -->
    @if (projectProperties && projectProperties.ProjectId > 0 && showTankBatteryTabs && showWellMappingTabFeatures) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['schedule'] === false}">
            {{ wellMappingTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <p>
            Well Planning Works
          </p>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Schedule -->
    @if (projectProperties && projectProperties.ProjectId > 0) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['schedule'] === false}">
            {{ scheduleTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-schedule
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTitle)="readScheduleTab($event)"
            (tabTdv)="readScheduleTabTdv($event)"
            #ProjectScheduleComponent>
          </app-project-schedule>
        </ng-template>
      </kendo-tabstrip-tab>
    }
    <!-- Estimates -->
    @if (projectProperties && projectProperties.ProjectId > 0) {
      <kendo-tabstrip-tab class="flex-column">
        <ng-template kendoTabTitle>
          <div [ngClass]="{'invalid-tab': validateTabs['estimates'] === false}">
            {{ estimatesTabTitle | titlecase }}
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <app-project-estimate-home
            class="full-size flex-100"
            [projectTab]="projectProperties"
            (tabTitle)="readEstimateTab($event)"
            (tabTdv)="readEstimateTabTdv($event)"
            #AppProjectEstimates></app-project-estimate-home>
        </ng-template>
      </kendo-tabstrip-tab>
    }
  </kendo-tabstrip>

</div>